// ---------------------------------------------------------------------------
// OverallStyles — scoped keyframes / hover / focus for the "All Schools Today"
// view. Everything else is inline (ported from prompt/overall.html); only the
// rules that can't be expressed inline live here, scoped under `.dgo`.
// ---------------------------------------------------------------------------
import React from "react";

const CSS = `
/* Clear the floating admin navbar (absolute, ~75px tall near the viewport top)
   so the dark title bar and its View dropdown aren't hidden under it. */
.dgo{padding-top:70px}
@media (max-width:767px){.dgo{padding-top:120px}}
.dgo{font-family:'Mukta','Noto Sans Devanagari',system-ui,sans-serif;color:#09152B}
.dgo a{color:#0B66DB}
.dgo a:hover{color:#084FA8}
@keyframes dgoPulse{0%{box-shadow:0 0 0 0 rgba(4,126,79,.45)}70%{box-shadow:0 0 0 8px rgba(4,126,79,0)}100%{box-shadow:0 0 0 0 rgba(4,126,79,0)}}
@keyframes dgoBlink{0%,100%{opacity:1}50%{opacity:.35}}
.dgo .dg-live{animation:dgoPulse 1.8s infinite}
.dgo .dg-next{animation:dgoBlink 1.4s infinite}
.dgo .dg-card{transition:transform .15s ease, box-shadow .15s ease}
.dgo .dg-card:hover{transform:translateY(-2px);box-shadow:0 10px 24px rgba(9,21,43,.10)}
.dgo .dg-card:focus-visible,.dgo .dg-btn:focus-visible,.dgo .dg-field:focus-visible{outline:3px solid #FFB305;outline-offset:2px}
.dgo .dg-field::placeholder{color:#6B7486}
`;

export default function OverallStyles() {
    return <style>{CSS}</style>;
}
